var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b',{staticClass:"text-success"},[_vm._v(" ("),_vm._t("default",function(){return [_vm._v("automatycznie")]}),_vm._v(") ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }